'use client'

import { CommunityEstablishedBadge } from '@/components/_community/community-established-badge'
import HandshakeIcon from '@/components/icons/handshake'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import { ExternalLink } from 'lucide-react'
import Image from 'next/image'
import Link from 'next/link'

export default function CommunityCard({ community, communityId }) {
  const showTag =
    community.partneredStatus === 'partnered' || community.isShowcase

  return (
    <div className="flex h-full flex-col rounded-sm border border-neutral-blue-700 bg-neutral-blue-800">
      <div className="aspect-342/193 desktop-xs:aspect-321/181 relative w-full">
        <Image
          src={community.headerImgUrl || '/img/default/header.webp'}
          alt="Community Header Image"
          fill
          className="rounded-sm object-cover"
        />
      </div>

      <div className="z-1 relative -mt-10 grid size-20 self-center rounded-sm border border-shades-0 bg-neutral-blue-800 desktop-xs:mt-[-38px] desktop-xs:size-[76px]">
        <Image
          src={community.logoImgUrl || '/img/default/header.webp'}
          alt="Community Header Image"
          fill
          className="rounded-sm object-cover"
        />
      </div>

      <div className="flex flex-1 flex-col justify-between">
        <div className="flex w-full flex-col items-center">
          {/* TODO how do we handle this? */}

          {showTag && (
            <div
              className={cn(
                'mt-3 flex h-[32px] items-center gap-1 rounded-full px-3',
                {
                  'bg-warning-50': community.partneredStatus === 'partnered',
                  'bg-neutral-blue-700': community.isShowcase,
                },
              )}
            >
              {community.partneredStatus === 'partnered' ? (
                <>
                  <HandshakeIcon className="size-4 stroke-[#F54907] stroke-[3px]" />
                  <p className="gf-gradient-text text-cap font-bold">
                    Partnered
                  </p>
                </>
              ) : (
                community.isShowcase && (
                  <>
                    <p className="gf-gradient-text text-cap font-bold">
                      Listed
                    </p>
                    <ExternalLink className="size-4 stroke-neutral-blue-300" />
                  </>
                )
              )}
            </div>
          )}

          <p className="mt-2 text-center text-h-5-sm font-semibold first:mt-8 desktop-xs:text-h-6-sm">
            {community.name}
          </p>

          <p className="mt-2 text-center text-p-2 font-semibold text-neutral-blue-200 desktop-xs:text-p-1">
            {community._stats.members.all} Members
          </p>

          <CommunityEstablishedBadge
            className="mt-2"
            createTs={community.createTs}
          />
        </div>

        <Button
          asChild
          className="border! border-neutral-blue-600! bg-neutral-blue-700! text-shades-0! hover:bg-shades-0! hover:text-neutral-blue-900! m-3 h-[66px] transition-all duration-300 ease-in-out desktop-xs:h-[62px]"
        >
          <Link href={`/c/${community.slug || community.id}`}>
            View Community
          </Link>
        </Button>
      </div>
    </div>
  )
}
